import * as React from 'react';

const Telephone24 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 24 24", width: 24, height: 24, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16.001 22.5c-3.3 0-7.4-5-8.7-7.1-1.2-1.9-3.4-7-2.6-10.1.2-1 .8-1.8 1.5-2.2l2.5-1.5c.3-.3.8-.4 1.2-.3.5.1.9.5 1 1l1.7 4c.4.8.2 1.8-.5 2.3l-2 1.2c.2 1.2 2.5 5.1 3.5 5.8l1.9-1.2c.3-.2.8-.3 1.3-.2s.9.4 1.1.7l2.7 3.4c.3.3.4.7.4 1.2s-.3.9-.7 1.2l-2.8 1.5q-.75.3-1.5.3m-6.5-19.7-2.6 1.6c-.4.2-.7.6-.8 1.2-.6 2.5 1.3 7.2 2.4 9 1.9 2.9 6.2 7.4 8.2 6.2l2.8-1.5-.1-.1-2.7-3.4c-.1-.1-.3-.2-.4-.1l-2.2 1.3c-.4.2-1.5.8-4.1-3.8-1.9-3.4-1.5-4.2-.9-4.6l2.2-1.3c.1-.1.1-.3 0-.4z"
  }
));
Telephone24.Size = 24;
Telephone24.Title = "Telephone";

export { Telephone24 as default };
